import { Component, Input } from "@angular/core";
import { FormGroup } from "@angular/forms";

import { FormToolsService, MainConfig } from "@atenea-cms";
import { ProductFormService } from "../shared";

@Component({
  selector: "product-videos-form",
  templateUrl: "./product-videos-form.component.html",
  styleUrls: ["./product-videos-form.component.scss"],
})
export class ProductVideosFormComponent {
  @Input() form: FormGroup;

  textColorOptions: Array<Object> = [];
  config: any = {};

  constructor(
    public ft: FormToolsService,
    public formService: ProductFormService,
    public mainConfig: MainConfig
  ) {
    this.config = this.mainConfig.modules;

    this.textColorOptions = [
      { value: "light", label: "Claro" },
      { value: "dark", label: "Oscuro" },
    ];
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/product-videos-form/product-videos-form.component.ts